export default __webpack_public_path__ + "static/media/chanel.bf0f7950.svg";